<template>
  <div id="landing3" v-observe-visibility="{
    callback: visibilityChanged,
    once: true,
  }" >
    <v-layout column wrap align-center justify-center>
      <v-flex>
        <transition name="fadeintro">
          <div v-if="showIntro" class="landing3-box">
            <h2 class="white--text">Penrith Drainage Survey</h2>
            <p>An example of asset capture, ThinkSpatial was commissioned by the Penrith Council to undertake a comprehensive survey of the Council's drainage network.</p>
            <v-btn class="mx-2" fab small color="green" v-on:click="animateMap">
              <v-icon dark>play_arrow</v-icon>
            </v-btn>          
          </div>
        </transition>
        <transition name="fadeintro">
          <div v-if="!showIntro" class="landing3-box small-box">
            <v-btn class="mx-2" fab small color="green" v-on:click="animateMap">
              <v-icon dark>pause</v-icon>
            </v-btn>          
          </div>
        </transition>        
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import PublicLandingApi from '@/services/PublicLandingApi';
import Mapbox from 'mapbox-gl'
export default {
  data () {
    return {
      showIntro: true,
      animationId: null,
      landing3: null,
      pits: null,
      pipes: null,
      token: 'pk.eyJ1IjoiYWdhdXNzZW4iLCJhIjoiY2oydXp1dmg0MDAxeDJ2azJjOTM1Y202MCJ9.snYgaaG8eVpXPGw120O5Pg',
    }
  },
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    intervalRorateMap() {
      return window.setInterval(()=> {
          var current = this.landing3.getBearing();
          var rotateNumber = current;
          this.landing3.rotateTo(rotateNumber + 5, {duration: 490, easing: function(t) {return t;}});
        }, 500 );
    },  
    animateMap(){
      this.showIntro = !this.showIntro
      if(!this.showIntro) {
        this.animationId = this.intervalRorateMap();
      } else {
        setTimeout(()=>{
          window.clearInterval(this.animationId);
          this.animationId = null;
        },0);
      }
    },
    visibilityChanged(){
      console.log('Resize landing3')
      this.landing3.resize();
    },
    async getFeatures() {
      await this.sleep(7000)
      const response = await PublicLandingApi.heros('pits')
      this.pits = JSON.parse(response.data.fc)
      this.landing3.addSource('pits', {
        'type': 'geojson', 
        'data': this.pits 
      })
      this.landing3.addLayer({
        'id': 'pits',
        'type': 'circle',
        'source': 'pits',
        'paint': {
          'circle-radius': 3,
          'circle-opacity': 1,   
          'circle-color': {
            'property': 'LidType', 
            'type': 'categorical',
            'stops': [
                ['CA',   '#78bda9'],
                ['NULL', '#A29354'],
                ['CI',   '#dbc389'],
                ['CO',   '#3cdb69'],
                ['F',    '#98db5d'],
                ['GA',   '#7f92d5'],
                ['GR',   '#ee9b1d'],
                ['UNK',  '#d822a5']
            ]
          }
        }
      });
      const response2 = await PublicLandingApi.heros('pipes')
      this.pipes = JSON.parse(response2.data.fc)
      this.landing3.addSource('pipes', {
        'type': 'geojson', 
        'data': this.pipes 
      })      
      this.landing3.addLayer({
        'id': 'pipes',
        'type': 'line',
        'source': 'pipes',
        'paint': {
          'line-width': 3,
          'line-opacity': 1,
          'line-color': {
            'property': 'PipeDiameter', 
            'type': 'interval',
            'stops': [
              [0,    '#00E5E3'],
              [200,  '#06D8E1'],
              [200,  '#0DCCDF'],
              [400,  '#14C0DD'],
              [500,  '#1BB4DB'],
              [600,  '#22A8D9'],
              [700,  '#299CD7'],
              [800,  '#2F90D5'],
              [900,  '#3684D3'],
              [1000, '#3D78D1'],
              [1100, '#446CD0'],
              [1200, '#4B60CE'],
              [1300, '#5254CC'],
              [1400, '#5848CA'],
              [1500, '#5F3CC8'],
              [1600, '#6630C6'],
              [1700, '#6D24C4'],
              [1800, '#7418C2'],
              [1900, '#7B0CC0'],
              [2100, '#8200BF']
            ]
          }  
        }
      });
    },    
  },
  mounted(){
    this.$nextTick(function () {
      Mapbox.accessToken = this.token
      let map = new Mapbox.Map({
        container: 'landing3',
        style: 'mapbox://styles/mapbox/satellite-v9',
        pitch: 60,
        center: [150.69588, -33.77267],
        zoom: 15,
        interactive: false
      });
      this.landing3 = map;
      map.on('load', ()=> {
        this.getFeatures()
      })
    })
  }
}
</script>

<style>
  #landing3 {
    height: 100%;
    width: 100%;
  }

  .fadeintro-enter-active, .fadeintro-leave-active {
    transition: opacity .5s;
  }

  .fadeintro-enter, .fadeintro-leave-to {
    opacity: 0;
  }

  .landing3-box {
    position: absolute;
    left: 10%;
    bottom: 60px;
    z-index: 5;
    background-color: #f1592a;
    padding: 5px;
    text-align: center;
    line-height: 30px;
    padding-left: 10px;
    max-width: 250px;
  }

  .small-box {
    padding: 5px;
    border-radius: 35px;
  }

  .landing3-box p {
    color: #fff;
    box-sizing: border-box;
    line-height: 18px;
  }  
</style>